import About from "./Page/About";
import Contact from "./Page/Contact";
import Footer from "./Page/Footer";
import Header from "./Page/Header";
import Service from "./Page/Service";
import Service2 from "./Page/Service2";

function Acceuil() {
  return (
    <div className="Acceuil">
      <Header />
      <Service />
      <Service2 />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}

export default Acceuil;